import {AfterViewInit, Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";
import {User} from "../domain/user";
import {FILE_UPLOAD_DIRECTIVES} from "ng2-file-upload/ng2-file-upload";
import {Bank} from "../domain/bank";
import {BankService} from "../service/bank.service";
import {KmFormat} from "../validators/validators";
import {ProcedureService} from "../service/procedure.service";
import {Contract} from "../domain/contract";
import {NavigationService} from "../service/navigation.service";

@Component({
    selector: 'pendingProcedures-panel',
    template: require('./pendingProcedures.panel.component.html'),
    styles: [require('./pendingProcedures.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [PaginatePipe, KmFormat],
})
export class PendingProceduresPanelComponent implements OnInit, AfterViewInit {

    private data: Contract[]; // TODO: ver si estan de mas

    private banks: Bank[]; // TODO: ver si estan de mas

    public bankTodos: Bank;

    private filter: Vehicle;

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    private userLogged: User;

    public canEditProcedure: boolean;
    public canViewProcedure: boolean;

    public showFilters: boolean;


    constructor(private router: Router,
                private procedureService: ProcedureService,
                private bankService: BankService,
                private loginService: LoginService, private navigationService: NavigationService) {
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/
    }

    private init(): void {
        this.data = [];

        this.banks = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        this.canEditProcedure = false;
        this.canViewProcedure = false;

        this.showFilters = false;

        this.filter = new Vehicle();
        this.form = new FormGroup({
            bank: new FormControl(),
            contractNumber: new FormControl(),
            cuit: new FormControl(),
            itemsPerPage: new FormControl(),
            withDocuments: new FormControl()
        });

        if (!this.filter.contract.bank.id) {
            this.filter.contract.bank = this.bankTodos;
        }

    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !((this.filter.contract.contractNumber || this.filter.contract.cuit)
            || (this.filter.contract.bank && this.filter.contract.bank.id != ''));
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.contract.bank = banks[0];
        }
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;
        if (!this.filterEmpty()) {
            this.loading = true;
            this.procedureService.findPendingProcedure(this.filter, page, this.itemsPerPage).subscribe(
                (data) => {
                    this.refreshData(data);
                    this.page = page;
                },
                () => {
                    this.bindError('Ocurrió un error al buscar los vehículos.');
                });
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public editItem(item: Vehicle): void {
        this.navigationService.setBackParameters({tabSelected: 'pendingProcedures'});
        this.router.navigate(['app/home/editPendingProcedure', item.id]);
    }

    public close(saved: Vehicle): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        this.canEditProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'EDIT', 'PROCEDURES');
        this.canViewProcedure = this.userLogged.isActionAllowed('PROCEDURES', 'VIEW', 'PROCEDURES');

        if (this.userLogged.rol.client) {
            if (this.userLogged.cuit) {
                this.filter.contract.cuit = this.userLogged.username;
            } else {
                this.filter.patent = this.userLogged.username;
            }
            this.filter.contract.bank.id = this.userLogged.bank.id;
            this.showFilters = false;
        } else {
            this.showFilters = true;
        }
        this.getPage(1);
    }


    public ngAfterViewInit() {

    }

    public disableLoading(): void {
        this.loading = false;
    }

    public enableLoading(): void {
        this.loading = true;
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

}


/** WEBPACK FOOTER **
 ** ./src/app/pendingProcedures/pendingProcedures.panel.component.ts
 **/